import { render, staticRenderFns } from "./uploadInvoices.vue?vue&type=template&id=bdcd35b2&scoped=true"
import script from "./uploadInvoices.vue?vue&type=script&lang=js"
export * from "./uploadInvoices.vue?vue&type=script&lang=js"
import style0 from "./uploadInvoices.vue?vue&type=style&index=0&id=bdcd35b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcd35b2",
  null
  
)

export default component.exports